import { Controller } from "@hotwired/stimulus"

// Inline edit-in-place for the D2 settings cards. Toggles a card between its
// read-only `.display-mode` blocks and the hidden `.edit-mode` <form> using the
// `.hidden` utility. Both the head action buttons (Edit ⇄ Save/Cancel) and the
// body blocks carry the display/edit targets, so a single toggle flips them in
// lockstep. Save is the form's own submit (a normal Turbo POST to the existing
// update action); Cancel restores the display block and resets the form so
// unsaved edits are discarded.
export default class extends Controller {
  static targets = ["display", "edit", "form"]

  start(event) {
    event?.preventDefault()
    this.displayTargets.forEach((el) => el.classList.add("hidden"))
    this.editTargets.forEach((el) => el.classList.remove("hidden"))
    const firstField = this.editTargets[0]?.querySelector("input:not([type=hidden]), select, textarea")
    if (firstField) firstField.focus()
  }

  cancel(event) {
    event?.preventDefault()
    if (this.hasFormTarget) this.formTarget.reset()
    this.editTargets.forEach((el) => el.classList.add("hidden"))
    this.displayTargets.forEach((el) => el.classList.remove("hidden"))
  }
}
